import apiClient from './apiClient'

export interface AresSubject {
  ico: string
  obchodniJmeno: string
  dic: string | null
  pravniForma: string | null
  isFyzickaOsoba: boolean
  datumVzniku: string | null
  datumZaniku: string | null
  isAktivni: boolean
  isVatPayer: boolean
  vatStatus: string   // AKTIVNI | NEEXISTUJICI | ZANIKLÝ | NEZNAMY
  sidlo: string | null
  sidloPsc: string | null
  sidloObec: string | null
  fetchedAt: string
}

export const aresService = {
  getSubject: (ico: string) =>
    apiClient.get<AresSubject>(`/ares/${ico}`).then(r => r.data),
}
